import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MQService, ConfigService } from '@ngxsuit';
import { HttpClient } from '@angular/common/http';

declare type Callback = () => void;

interface NOTIFY_MSG {
    brief:string,
    detail:string
    time?:number,
}

interface FrontStore
{
    name: string;
    base_url: string;
    notifications?: NOTIFY_MSG[]
};

interface HttpParams {
    [key:string]: string|number
}

@Injectable( {
    providedIn: 'root',
})
export class StoreService {
    public stores: FrontStore[];
    private current: FrontStore = {
        name: 'Default',
        base_url: ''
    };

    private basicUrl: string = '';
    private storesReady: boolean = false;

    private initstate: number = 0;

    constructor(protected mq:MQService,
        private http:HttpClient,
        private config:ConfigService) {
        this.basicUrl = this.config.getString('base_url') + this.basicUrl;
        this.stores = [];
        this.fetchStoreList();
        if (localStorage.getItem('frontstore')){
            this.current = <FrontStore>(JSON.parse(localStorage.getItem('frontstore')));
        }

        this.mq.listenOn('push-msg-received:neworder').subscribe(msg => {
            const {data} = msg;
            const { store, order_id} = data;
            this.stores.forEach(storeFront => {
                console.log('push-msg-received:neworder tony ', msg);
                if (store.toUpperCase() === storeFront.name.toUpperCase()) {
                    storeFront.notifications = storeFront.notifications || [];
                    storeFront.notifications.push({brief:'new order', detail:order_id, time: (new Date).getTime()});
                    console.log('push-msg-received:neworder tony store', storeFront);
                }
            })
        })
    }

    private fetchStoreList() {
        const stores = this.config.get('stores');
        if (stores) {
            this.stores = <FrontStore[]>this.config.get('stores');
            this.stores.forEach(store => {
                store.notifications = [];
            })
            this.mq.notify('stores-ready', { stores: this.stores });
            this.storesReady = true;
        }
    }

    public callWhenStoresReady(callback: Callback) {
        if (this.storesReady) {
            callback();
        }
    }

    public changeStore(storeName: string, router: Router) {
        let changed = false;
        if (this.stores.length > 0) {
            if (this.current && storeName === 'default') {
                const url = this.rebuildUrlByStoreName(router.url, this.current.name);
                changed = true;
                router.navigate([url]);
            } else {
                for (let store of this.stores) {
                    if (storeName === 'default' || storeName === store.name) {
                        changed = (this.current.name !== storeName);
                        this.current = store;
                        const url = this.rebuildUrlByStoreName(router.url, this.current.name);
                        router.navigate([url]);
                        break;
                    }
                }
                if (this.current) {
                    localStorage.setItem('frontstore', JSON.stringify(this.current));
                }
            }
            if (changed || this.initstate == 0) {
                this.mq.notify('store-changed', {store:this.current, time: (new Date).getTime()});
            }
            this.initstate++;
        }
    }

    public rebuildCurrentStoreUrl(url:string) {
        return this.rebuildUrlByStoreName(url, this.current.name);
    }

    public rebuildUrlByStoreName(url:string, storeName: string) {
        let routePaths = url.split('/');
        routePaths[2] = storeName;
        return routePaths.join("/");
    }

    public generateUrl(path: string | string[], params?: HttpParams) {
        if (this.current.base_url === '') {
            this.current.base_url = this.basicUrl;
        }
        this.current.base_url = '/api/admin';
        let paths = [this.current.base_url];
        if (typeof path !== 'string') {
            paths = paths.concat(path);
        } else {
            paths.push(path);
        }

        if (params) {
            let items = [];
            for (let key in Object.keys(params)) {
                if (params.hasOwnProperty(key)) {
                const value = encodeURI(String(params[key]));
                items.push(`${key}=${value}`);
                }
            }
            paths.push('?' + items.join('&'));
        }
        console.log('generateUrl', paths);
        return paths.join('/');
    }

    public getStoreName() {
        return this.current.name;
    }
}
